'use strict';

require('../less/about_us.less');

require('./page');

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

require('swiper/dist/css/swiper.min.css');

var _util = require('./common/util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var urlList = ['http://stage.investorroom.com/sunlands/corporate-profile', 'http://www.sunlands.investorroom.com/management', 'http://www.sunlands.investorroom.com/board-of-directors', 'http://www.sunlands.investorroom.com/committee-composition', 'http://www.sunlands.investorroom.com/corporate-governance', 'http://www.sunlands.investorroom.com/', 'http://www.sunlands.investorroom.com/sec-filings', 'http://www.sunlands.investorroom.com/financial-reports', 'http://www.sunlands.investorroom.com/', 'http://www.sunlands.investorroom.com/', 'http://www.sunlands.investorroom.com/stock-quote-chart', 'http://www.sunlands.investorroom.com/', 'http://www.sunlands.investorroom.com/press-releases', 'http://www.sunlands.investorroom.com/event-calendar', 'http://www.sunlands.investorroom.com/', 'http://www.sunlands.investorroom.com/', 'http://www.sunlands.investorroom.com/ir-contacts', 'http://www.sunlands.investorroom.com/email-alerts', 'http://www.sunlands.investorroom.com/contact-information'];
$(function () {
	// tab根据url的search显示是否被选中
	var tabs = $('.about-us-tabs').find('span');
	tabs.removeClass('active');
	var query = window.location.search.slice(1).split('&');
	for (var index = 0; index < query.length; index++) {
		var element = query[index];
		var se = element.split('=');
		if (se[0] === 'type') {
			switch (se[1]) {
				case '0':
					// 关于尚德
					$(tabs[0]).addClass('active');
					break;
				case '2':
					// 企业社会责任
					$(tabs[2]).addClass('active');
					break;
				case '3':
					// 新闻中心
					$(tabs[3]).addClass('active');
					break;
			}
		}
	}

	// $('.about-us-tabs span').click(function(){
	// 	$('.about-us-tabs span').removeClass('active')
	// 	$(this).addClass('active')
	// 	$('.about_us_tab_content').hide()
	// 	$('.about_us_tab_content').eq($(this).index()).show()

	// 	var oldUrl = window.location.href
	// 	window.location.href = oldUrl.substr(0,oldUrl.length-1)  + $(this).index()
	// })
	$('.about_us_footer_links span').click(function () {
		var index = $(this).index();
		$('.about-us-tabs span').removeClass('active');
		$('.about-us-tabs span').eq(index).addClass('active');
		$('.about_us_tab_content').hide();
		$('.about_us_tab_content').eq(index).show();

		var oldUrl = window.location.href;
		window.location.href = oldUrl.substr(0, oldUrl.length - 1) + index;
	});

	// $('.tab_item').click(function(){
	// 	var index = $(this).attr('data-urlq')
	// 	var url = '';
	// 	if(index=='8'){
	// 		url = 'http://www.sunlands.investorroom.com/Analyst-Coverage'
	// 	} else if(index=='14') {
	// 		url = 'http://www.sunlands.investorroom.com/webcasts-and-presentations'
	// 	} else {
	// 		url = urlList[index]
	// 	}
	// 	$('#investor_frame').attr('src',url)
	// 	switch(index){
	// 		case '0':
	// 			$('#investor_frame').css('height','1000px')
	// 			break;
	// 		case '1':
	// 			$('#investor_frame').css('height','1600px')
	// 			break;
	// 		case '2':
	// 			$('#investor_frame').css('height','3000px')
	// 			break;
	// 		case '3':
	// 			$('#investor_frame').css('height','800px')
	// 			break;
	// 		case '4':
	// 			$('#investor_frame').css('height','1000px')
	// 			break;
	// 		case '5':
	// 			$('#investor_frame').css('height','1000px')
	// 			break;
	// 		case '6':
	// 			$('#investor_frame').css('height','1000px')
	// 			break;
	// 		case '7':
	// 			$('#investor_frame').css('height','600px')
	// 			break;
	// 		case '8':
	// 			$('#investor_frame').css('height','1000px')
	// 			break;
	// 		case '9':
	// 			$('#investor_frame').css('height','1600px')
	// 			break;
	// 		case '10':
	// 			$('#investor_frame').css('height','600px')
	// 			break;
	// 		case '11':
	// 			$('#investor_frame').css('height','1000px')
	// 			break;
	// 		case '12':
	// 			$('#investor_frame').css('height','800px')
	// 			break;
	// 		case '13':
	// 			$('#investor_frame').css('height','600px')
	// 			break;
	// 		case '14':
	// 			$('#investor_frame').css('height','1000px')
	// 			break;
	// 		case '15':
	// 			$('#investor_frame').css('height','1000px')
	// 			break;
	// 		case '16':
	// 			$('#investor_frame').css('height','600px')
	// 			break;
	// 		case '17':
	// 			$('#investor_frame').css('height','600px')
	// 			break;
	// 		case '18':
	// 			$('#investor_frame').css('height','8000px')
	// 			break;
	// 	}
	// })

	var swiper = new _swiper2["default"]('#swiper-container-01', {
		slidesPerView: 4,
		spaceBetween: 20,
		freeMode: true,
		nextButton: '.swiper-button-next',
		prevButton: '.swiper-button-prev',
		loop: true
	});
	//初始化锚点
	var initIndex = _util2["default"].getURLParams()['type'];
	$('.about-us-tabs span').removeClass('active');
	$('.about-us-tabs span').eq(initIndex).addClass('active');
	$('.about_us_tab_content').hide();
	$('.about_us_tab_content').eq(initIndex).show();
	if (initIndex == 2) {
		var swiper = new _swiper2["default"]('#swiper-container-02', {
			pagination: '.swiper-pagination',
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			slidesPerView: 1,
			paginationClickable: true,
			spaceBetween: 30,
			loop: true
		});
	}

	//$('.about-us-tabs span').eq(util.getURLParams()['type']).click()
});


//////////////////
// WEBPACK FOOTER
// ./src/js/about_us.js
// module id = 16
// module chunks = 0